/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { FetchInstrumentation } from './fetch';
export type {
  FetchCustomAttributeFunction,
  FetchRequestHookFunction,
  FetchInstrumentationConfig,
} from './fetch';
